const sidebar = {
  'sidebar-pages': 'Страницы',
  'sidebar-other': 'Другое',
  'sidebar-notifications': 'Уведомления',
  'sidebar-rbac': 'Управление доступом',
  'sidebar-pages-rbac-users': 'Пользователи',
  'sidebar-featured': 'Рекомендуемые',
  'sidebar-featured-news': 'Новости',
  'sidebar-featured-old-news': 'Старые новости',
  'sidebar-featured-news-icons': 'Иконки',
  'sidebar-featured-news-dictionary': 'Переводы',
  'sidebar-featured-news-dictionary-btn': 'Переводы кнопок',
  'sidebar-featured-daily': 'Ежедневные',
  'sidebar-featured-editors-choice': 'Выбор редакторов',
  'sidebar-featured-external-promo': 'Внешние промо',
  'sidebar-pages-push-icons': 'Пуш иконки',
  'sidebar-pages-deeplinks': 'Глубинные ссылки',
  'sidebar-pages-reset-static-content': 'Сброс данных статики',
  'sidebar-pages-popups': 'Диалоги',
  'sidebar-pages-local-notifications': 'Локальные уведомления',
  'sidebar-pages-push-notifications': 'Серверные уведомления',
  'sidebar-pages-push-notifications-schedule': 'Расписание',
  'sidebar-pages-blank-page': 'Пустая страница',
  'sidebar-pages-error': 'Ошибки',
  'sidebar-view-profile': 'Профиль',
  'sidebar-translations': 'Переводы',
  'sidebar-content': 'Контент',
  'sidebar-content-images': 'Картинки',
  'sidebar-content-reserve-statistics': 'Статистика резерва',
  'sidebar-content-categories': 'Категории',
  'sidebar-content-achievements': 'Достижения',
  'sidebar-content-collections': 'Коллекции',
  'sidebar-content-feeds': 'Лента',
  'sidebar-content-bonuses': 'Бонусы',
  'sidebar-template-constructors': 'Конструктор шаблонов',
  'sidebar-templates': 'Шаблоны',
  'sidebar-templates-visualizations': 'Данные визуализации',
  'sidebar-presets': 'Пресеты',
  'sidebar-general-list': 'Список',
  'sidebar-general-priority': 'Приоритет',
  'sidebar-general-logs': 'Логи',
  'sidebar-content-feeds-released': 'Опубликовано',
  'sidebar-content-feeds-archived': 'Архив',
  'sidebar-content-feeds-planning': 'Планирование',
  'sidebar-content-feeds-trashed': 'Корзина',
};

export default sidebar;
